import React from 'react';

import styles from './TimeTable.module.scss';

export default function TimeTable({ data }) {
	const todayDay = new Date().getDay();

	const daysLabel = [
		'Lunedì',
		'Martedì',
		'Mercoledì',
		'Giovedì',
		'Venerdì',
		'Sabato',
		'Domenica'
	];

	return (
		<table className={styles.root}>
			<tbody>
				{daysLabel.map((dayLabel, i) => (
					<tr
						className={
							todayDay === i + 1 || todayDay === i - 6
								? styles.highlight
								: null
						}
						key={i}
					>
						<td className={styles.day}>{dayLabel}</td>
						<td className={styles.time}>
							{printTimeTableDay(data[i])}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	);
}

function printTimeTableDay(day) {
	if (!day.morningOpen && !day.afternoonOpen) {
		return 'CHIUSO';
	}

	let timeTableDay;

	if (day.morningOpen) {
		timeTableDay = day.morningOpen;

		if (day.morningClose) {
			timeTableDay += ' - ' + day.morningClose;
		} else if (day.afternoonClose) {
			timeTableDay += ' - ' + day.afternoonClose;
		}
	}
	if (day.morningOpen && day.afternoonOpen) {
		timeTableDay += ' / ';
	}
	if (day.afternoonOpen) {
		timeTableDay += day.afternoonOpen;

		if (day.afternoonClose) {
			timeTableDay += ' - ' + day.afternoonClose;
		}
	}

	return timeTableDay;
}
